import React, { useEffect, useState, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAlert } from 'react-alert';
import { UserContext } from "../../../UserContext";

import CenteredPageContainer from "../layout_components/CenteredPageContainer";
import Button from "../common_components/Button";
import TextButton from "../common_components/TextButton";
import InterviewsPageLayout from "../layout_components/InterviewsPageLayout";
import InterviewIcon from "../../../../../../assets/images/user_app/interviews_icon.svg"
import CenteredLoadingIcon from "../common_components/CenteredLoadingIcon";
import PlaceholderCardLayout from "../layout_components/PlaceholderCardLayout";
import InterviewCard from "./InterviewCard";

// API Calls
import InterviewsAPI from "../../api/api_calls/InterviewsAPI";



function InterviewsPage(props) {
    const { user, setUser, refreshUser } = useContext(UserContext);
    const alert = useAlert();
    const navigate = useNavigate();
    const [interviews, setInterviews] = useState([]);
    const [timeZone, setTimeZone] = useState("");
    const [loadInterviewsComplete, setLoadInterviewsComplete] = useState(false);



    const screenWidth = window.innerWidth;
    const isMobile = screenWidth < 840;

    useEffect(() => {
        // Grab information on this user

        async function getInterviews() {
            const result = await InterviewsAPI.index(navigate);

            if (result.success) {
                setInterviews(result.scheduled_events);
                setTimeZone(result.timezone);
                setLoadInterviewsComplete(true);
            } else {
                setLoadInterviewsComplete(false);
            }
        }

        getInterviews();
        document.title = 'Interviews | Despark';
    }, []);



    return (
        <CenteredPageContainer startAtTopMobile={true} noPadding={isMobile}>
            {/* Check if load is complete. Once it is, either put in placeholder or show the interviews */}
            {!loadInterviewsComplete ? <CenteredLoadingIcon />
                : interviews.length === 0 ?
                    <NoInterviewsPlaceholder />
                    :
                    <InterviewsPageLayout>
                        <InterviewsPageLayoutHeader isMobile={isMobile} />
                        <div className="interview-cards-container">
                            <InterviewCards interviews={interviews} timeZone={timeZone} />
                        </div>
                    </InterviewsPageLayout>
            }
        </CenteredPageContainer>
    )
}

function InterviewCards({ interviews }) {

    return (
        <>
            {interviews.map((interview) => (
                <InterviewCard
                    key={interview.id}
                    interview={interview}
                />
            ))}
        </>
    )

}

function InterviewsPageLayoutHeader(props) {
    return (
        <div className="interviews-page-layout-header">
            <h2>Interviews</h2>
        </div>
    )

}

function NoInterviewsPlaceholder() {
    const navigate = useNavigate();

    return (
        <div className="no-interviews-placeholder-container">
            <PlaceholderCardLayout>
                <img src={InterviewIcon} classalt="Interview" />
                <div className="placeholder-card-text-content-container">
                    <h1 className="centered-h1-card-text">Upcoming interviews will show here</h1>
                    <div className="centered-text body-medium grey-400-text">
                        Apply for missions and schedule interviews. You'll be able to see them all listed here.
                    </div>
                </div>
                <div className="full-width-button-container">
                    <Button size="large" fullWidth={true} color="primary" onClick={() => navigate("/missions")}>Explore missions</Button>
                </div>

            </PlaceholderCardLayout>
        </div>
    )
}


export default InterviewsPage